import styled from "styled-components";
import {Tab, Tabs, TabList, TabPanel} from "react-tabs";

// import colors from '../../constants/colors'
import breakpoints from "../../constants/breakpoints";
import fonts from "../../constants/fonts";

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  align-items: center;
`;

export const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 8%;
  & > h2 {
    margin: 0;
    font-size: 35px;
    font-weight: 400;
    line-height: 36px;
    @media screen and (max-width: ${breakpoints.ipad.pixels}) {
      font-size: 24px;
      line-height: 28px;
    }
  }
  & > section {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    max-width: 1440px;
    @media screen and (max-width: ${breakpoints.desktop.pixels}) {
      flex-direction: column;
    }

    & > div:first-of-type {
      width: 40%;
      margin: 0 20% 0 0;
      @media screen and (max-width: ${breakpoints.desktop.pixels}) {
        width: 100%;
      }
      @media screen and (max-width: ${breakpoints.desktop.pixels}) {
        margin: 0;
      }
      & > article {
        margin: 2% 0;
        font-size: 20px;
        font-weight: 400;
        line-height: 37px;
        @media screen and (max-width: ${breakpoints.ipad.pixels}) {
          font-size: 18px;
          line-height: 28px;
        }
      }
    }
    & > div:last-of-type {
      width: 40%;
      display: flex;
      flex-direction: column;
      @media screen and (max-width: ${breakpoints.desktop.pixels}) {
        width: 100%;
        margin: 16px 0 0 0;
      }
      & > span {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 8px 0;
        font-size: 20px;
        font-weight: 400;
        line-height: 37px;
        @media screen and (max-width: ${breakpoints.ipad.pixels}) {
          font-size: 16px;
          line-height: 28px;
        }
        & > svg {
          margin: 0 16px 0 0;
          min-width: 37px;
          @media screen and (max-width: ${breakpoints.ipad.pixels}) {
            transform: scale(0.6);
          }
        }
      }
    }
  }
`;

export const VideoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 80px 0;
  background-color: rgba(245, 164, 98, 0.05);
  width: 100vw;
  padding: 32px 8%;
  align-items: center;
  @media screen and (max-width: ${breakpoints.ipad.pixels}) {
    margin: 40px 0;
    padding: 0 8%;
  }
  & > div:first-of-type {
    max-width: 1440px;
    width: 100%;
    & > h2 {
      font-size: 35px;
      font-weight: 400;
      line-height: 36px;
      @media screen and (max-width: ${breakpoints.ipad.pixels}) {
        font-size: 24px;
        line-height: 28px;
      }
    }
  }
  & > div:last-of-type {
    max-width: 1024px;
    width: 100%;
    min-height: 600px;
    justify-content: center;
    display: flex;
    @media screen and (max-width: ${breakpoints.ipad.pixels}) {
      min-height: 0;
    }
  }
`;

export const InfoGraphics = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  padding: 0 8%;
  align-items: center;
  & > div:first-of-type {
    max-width: 1440px;
    width: 100%;
    & > h2 {
      font-size: 35px;
      font-weight: 400;
      line-height: 36px;
      @media screen and (max-width: ${breakpoints.ipad.pixels}) {
        font-size: 24px;
        line-height: 28px;
      }
    }
  }
  & > div:last-of-type {
    max-width: 1440px;
    width: 100%;
    display: flex;
    flex-direction: row;
    @media screen and (max-width: ${breakpoints.desktop.pixels}) {
      flex-direction: column;
    }
    & > span {
      width: 10%;
    }
    & section {
      display: flex;
      flex-direction: column;
      width: 100%;
      @media screen and (max-width: ${breakpoints.desktop.pixels}) {
        justify-content: center;
        align-items: center;
      }
      :first-of-type {
        & > a > div {
          background-position: center;
          background-repeat: no-repeat;
          object-fit: cover;
          background-size: 100% 100%;
          @media screen and (max-width: ${breakpoints.ipad.pixels}) {
            height: 237px;
          }
        }
      }
      :last-of-type {
        & > a > div {
          background-position: center;
          background-repeat: no-repeat;
          object-fit: cover;
          background-size: 100% 100%;
          @media screen and (max-width: ${breakpoints.ipad.pixels}) {
            height: 237px;          }
        }
      }
      & > a {
        outline: none;
        text-decoration: none;
        & > div {
          width: 100%;
          max-width: 496px;
          height: 346px;
          border: 9px solid #f5a462;
          background-color: #e86f51;
          border-radius: 16px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          @media screen and (max-width: ${breakpoints.ipad.pixels}) {
            max-width: 340px;
          }
          & > svg {
            transform: scale(0.8);
          }
          & > span {
            color: white;
            margin: 0 0 24px 0;
            font-size: 30px;
            font-weight: 400;
            line-height: 36px;
            @media screen and (max-width: ${breakpoints.ipad.pixels}) {
              font-size: 20px;
            }
          }
          &:hover {
            & > svg {
              transform: scale(1);
              transition: all 350ms ease-out;
            }
          }
        }
      }
      & > a {
        outline: none;
        text-decoration: none;
        width: 496px;
        display: flex;
        flex-direction: column;
        align-items: center;
        & > button {
          margin: 16px 0;
          height: 64px;
          color: #f5a462;
          background-color: transparent;
          outline: none;
          border: none;
          cursor: pointer;
          max-width: 496px;
          font-size: 25px;
          font-weight: 400;
          line-height: 36px;
          @media screen and (max-width: ${breakpoints.ipad.pixels}) {
            font-size: 20px;
          }
          &:hover {
            background-color: rgba(245, 164, 98, 0.07);
            border-radius: 14px;
          }
        }
      }
    }
  }
`;

export const Lessons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 0 80px 0;
  width: 100vw;
  padding: 0 8%;
  align-items: center;
  background-color: ${(props) => (props.bgc ? "rgba(245, 164, 98, 0.05)" : "white")};
  @media screen and (max-width: ${breakpoints.ipad.pixels}) {
    margin: 0;
  }
  & > div:first-of-type {
    max-width: 1440px;
    width: 100%;
    & > h2 {
      font-size: 35px;
      font-weight: 400;
      line-height: 36px;
      @media screen and (max-width: ${breakpoints.ipad.pixels}) {
        font-size: 24px;
        line-height: 28px;
      }
    }
    & > p {
      width: 80%;
      font-size: 20px;
      font-weight: 400;
      line-height: 37px;
      font-family: ${fonts.primary}, Helvetica, sans-serif;
      & > label {
        font-size: 10px;
        margin: 0;
      }
      @media screen and (max-width: ${breakpoints.ipad.pixels}) {
        font-size: 18px;
        line-height: 28px;
        width: 100%;
      }
    }
  }
  & span {
    display: flex;
    width: 25%;
    align-items: center;
    height: 50px;
    font-size: 20px;
    font-weight: 400;
    line-height: 37px;
    color: #7d7d7d;
    @media screen and (max-width: ${breakpoints.desktop.pixels}) {
      font-size: 18px;
      line-height: 28px;
      width: 100%;
      height: 20px;
    }
  }
`;

export const FiltersTabs = styled(Tabs)`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const FiltersTabList = styled(TabList)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  & > .react-tabs__tab--selected {
    background-color: #f5a462;
    color: white;
    font-size: 20px;
    font-weight: 400;
    line-height: 36px;
    &:hover {
      background-color: #f5a462;
    }
  }
`;

export const FilterTab = styled(Tab)`
  width: 168px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 52px;
  border-radius: 38px;
  border: 3px solid #f5a462;
  color: #f5a462;
  cursor: pointer;
  margin: 0 16px 0 0;
  font-size: 20px;
  font-weight: 400;
  line-height: 36px;
  &:hover {
    background-color: rgba(245, 164, 98, 0.6);
    color: white;
  }
`;

export const FilterTabPanelLessonOne = styled(TabPanel)`
  display: none;
  height: 100%;
  margin: 36px 0;
  :first-of-type {
    & > div {
      :first-of-type {
        & > section:first-of-type {
          & > a > div:first-of-type {
            background-image: url(${require("./energiaUno.png")});
            background-position: center;
            background-repeat: no-repeat;
            object-fit: cover;
            background-size: 100% 100%;
            @media screen and (max-width: ${breakpoints.ipad.pixels}) {
              height: 237px;
            }
          }
        }
      }
      :last-of-type {
        & > section:last-of-type {
          & > a > div:first-of-type {
            background-image: url(${require("./energiaDue.png")});
            background-position: center;
            background-repeat: no-repeat;
            object-fit: cover;
            background-size: 100% 100%;
            @media screen and (max-width: ${breakpoints.ipad.pixels}) {
              height: 237px;
            }
          }
        }
      }
    }
  }
  :last-of-type {
    & > div {
      :first-of-type {
        & > section:first-of-type {
          & > a > div:first-of-type {
            background-image: url(${require("./mobilitaUno.png")});
            background-position: center;
            background-repeat: no-repeat;
            object-fit: cover;
            background-size: 100% 100%;
            @media screen and (max-width: ${breakpoints.ipad.pixels}) {
              height: 237px;
            }
          }
        }
      }
      :last-of-type {
        & > section:last-of-type {
          & > a > div:first-of-type {
            background-image: url(${require("./mobilitaDue.png")});
            background-position: center;
            background-repeat: no-repeat;
            object-fit: cover;
            background-size: 100% 100%;
            @media screen and (max-width: ${breakpoints.ipad.pixels}) {
              height: 237px;
            }
          }
        }
      }
    }
  }
  & > div {
    max-width: 1440px;
    width: 100%;
    display: flex;
    flex-direction: row;
    @media screen and (max-width: 1200px) {
      flex-direction: column;
    }

    & > span {
      width: 10%;
    }
    & section {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 1440px;
      align-items: center;
      @media screen and (max-width: 1200px) {
        justify-content: center;
        align-items: center;
      }

      & > a {
        outline: none;
        text-decoration: none;
        width: 496px;
        display: flex;
        flex-direction: column;
        align-items: center;
        @media screen and (max-width: ${breakpoints.ipad.pixels}) {
          max-width: 340px;
        }

        & > div {
          width: 100%;
          max-width: 496px;
          height: 346px;
          border: 4px solid #f5a462;
          background-color: #5698c0;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          @media screen and (max-width: ${breakpoints.ipad.pixels}) {
            max-width: 340px;
          }
          & > svg {
            transform: scale(0.8);
          }
          & > span {
            color: white;
            margin: 0 0 24px 0;
          }
          &:hover {
            & > svg {
              transform: scale(1);
              transition: all 350ms ease-out;
            }
          }
        }
      }
      & > a {
        width: 496px;
        display: flex;
        justify-content: center;
        text-decoration: none;
      }
      & button {
        margin: 16px 0;
        height: 64px;
        color: #f5a462;
        background-color: transparent;
        outline: none;
        border: none;
        cursor: pointer;
        max-width: 496px;
        font-size: 25px;
        font-weight: 400;
        line-height: 36px;
        @media screen and (max-width: ${breakpoints.ipad.pixels}) {
          font-size: 20px;
        }
        &:hover {
          background-color: rgba(245, 164, 98, 0.07);
          border-radius: 14px;
        }
      }
    }
  }
`;

export const FilterTabPanelLessonTwo = styled(TabPanel)`
  display: none;
  height: 100%;
  margin: 36px 0;
  :first-of-type {
    & > div {
      :first-of-type {
        & > section:first-of-type {
          & > a > div:first-of-type {
            background-image: url(${require("./voceUno.png")});
            background-position: center;
            background-repeat: no-repeat;
            object-fit: cover;
            background-size: 100% 100%;
            @media screen and (max-width: ${breakpoints.ipad.pixels}) {
              height: 237px;
            }
          }
        }
        & > section:last-of-type {
          & > a > div:first-of-type {
            background-image: url(${require("./voceDue.png")});
            background-position: center;
            background-repeat: no-repeat;
            object-fit: cover;
            background-size: 100% 100%;
            @media screen and (max-width: ${breakpoints.ipad.pixels}) {
              height: 237px;
            }
          }
        }
      }
      :last-of-type {
        & > section:last-of-type {
          & > a > div:first-of-type {
            background-image: url(${require("./voceTre.png")});
            background-position: center;
            background-repeat: no-repeat;
            object-fit: cover;
            background-size: 100% 100%;
            @media screen and (max-width: ${breakpoints.ipad.pixels}) {
              height: 237px;
            }
          }
        }
      }
    }
  }

  & > div {
    max-width: 1440px;
    width: 100%;
    display: flex;
    flex-direction: row;
    @media screen and (max-width: 1200px) {
      flex-direction: column;
    }

    & > span {
      width: 10%;
    }
    & section {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 1440px;
      align-items: center;
      @media screen and (max-width: 1200px) {
        justify-content: center;
        align-items: center;
      }

      & > a {
        outline: none;
        text-decoration: none;
        width: 496px;
        display: flex;
        flex-direction: column;
        align-items: center;
        @media screen and (max-width: ${breakpoints.ipad.pixels}) {
          max-width: 340px;
        }

        & > div {
          width: 100%;
          max-width: 496px;
          height: 346px;
          border: 4px solid #f5a462;
          background-color: #5698c0;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          @media screen and (max-width: ${breakpoints.ipad.pixels}) {
            max-width: 340px;
          }
          & > svg {
            transform: scale(0.8);
          }
          & > span {
            color: white;
            margin: 0 0 24px 0;
          }
          &:hover {
            & > svg {
              transform: scale(1);
              transition: all 350ms ease-out;
            }
          }
        }
      }
      & > a {
        width: 496px;
        display: flex;
        justify-content: center;
        text-decoration: none;
      }
      & button {
        margin: 16px 0;
        height: 64px;
        color: #f5a462;
        background-color: transparent;
        outline: none;
        border: none;
        cursor: pointer;
        max-width: 496px;
        font-size: 25px;
        font-weight: 400;
        line-height: 36px;
        @media screen and (max-width: ${breakpoints.ipad.pixels}) {
          font-size: 20px;
        }
        &:hover {
          background-color: rgba(245, 164, 98, 0.07);
          border-radius: 14px;
        }
      }
    }
  }
`;

export const Quizzes = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 80px 0;
  width: 100vw;
  padding: 0 8%;
  align-items: center;
  @media screen and (max-width: ${breakpoints.ipad.pixels}) {
    margin: 0 0 20px 0;
  }
  & > div:first-of-type {
    max-width: 1440px;
    width: 100%;
    & > h2 {
      font-size: 35px;
      font-weight: 400;
      line-height: 36px;
      @media screen and (max-width: ${breakpoints.ipad.pixels}) {
        font-size: 24px;
        line-height: 28px;
      }
    }
    & > p {
      width: 80%;
      font-size: 20px;
      font-weight: 400;
      line-height: 37px;
      @media screen and (max-width: ${breakpoints.ipad.pixels}) {
        font-size: 18px;
        line-height: 28px;
        width: 100%;
      }
    }
    & span {
      display: flex;
      width: 25%;
      align-items: center;
      height: 50px;
      font-size: 20px;
      font-weight: 400;
      line-height: 37px;
      color: #7d7d7d;
      @media screen and (max-width: ${breakpoints.desktop.pixels}) {
        font-size: 18px;
        line-height: 28px;
        width: 100%;
        height: 20px;
      }
    }
  }
`;

export const FilterTabPanelQuiz = styled(TabPanel)`
  display: none;
  height: 100%;
  margin: 36px 0;
  & > div {
    max-width: 1440px;
    width: 100%;
    display: flex;
    flex-direction: column;
    & div {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 36px;
      margin: 16px 0;
      @media screen and (max-width: ${breakpoints.ipad.pixels}) {
        height: auto;
      }
      & a {
        text-decoration: none;
        color: #4d4d4d;
      }
      & button {
        cursor: pointer;
        outline: none;
        background-color: transparent;
        height: 52px;
        width: 168px;
        border-radius: 30px;
        margin: 0 32px 0 0;
        border: none;
        color: #f5a462;
        font-size: 20px;
        font-weight: 400;
        line-height: 36px;
        @media screen and (${breakpoints.ipad.pixels}) {
          display: none;
        }
        &:hover {
          background-color: rgba(245, 164, 98, 0.07);
          border-radius: 14px;
        }
      }
      & p {
        font-size: 20px;
        font-weight: 400;
        line-height: 37px;
        text-decoration: none;
        @media screen and (max-width: ${breakpoints.ipad.pixels}) {
          border: 1px solid rgba(245, 164, 98, 0.8);
          border-radius: 30px;
          padding: 0 16px;
          margin: 0;
        }
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;

export const Certification = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  padding: 32px 8%;
  align-items: center;
  @media screen and (max-width: ${breakpoints.ipad.pixels}) {
    padding: 0 8% 32px 8%;
  }
  & > div:first-of-type {
    max-width: 1440px;
    width: 100%;
    & > h2 {
      font-size: 35px;
      font-weight: 400;
      line-height: 36px;
      @media screen and (max-width: ${breakpoints.ipad.pixels}) {
        font-size: 24px;
        line-height: 28px;
      }
    }
    & > p {
      width: 80%;
      font-size: 20px;
      font-weight: 400;
      line-height: 37px;
      @media screen and (max-width: ${breakpoints.ipad.pixels}) {
        font-size: 18px;
        line-height: 28px;
        width: 100%;
      }
    }
    & div {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 52px;
      margin: 16px 0 32px 0;

      & a {
        text-decoration: none;
        color: #4d4d4d;
      }
      & button {
        margin: 0 32px 0 0;
        height: 52px;
        padding: 0 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: white;
        border: none;
        background-color: #f5a462;
        border-radius: 30px;
        cursor: pointer;
        font-size: 20px;
        font-weight: 400;
        line-height: 36px;
        @media screen and (max-width: ${breakpoints.ipad.pixels}) {
          display: none;
        }
        &:hover {
          background-color: rgba(245, 164, 98, 0.8);
        }
      }
      & p {
        font-size: 20px;
        font-weight: 400;
        line-height: 37px;
        text-decoration: none;
        @media screen and (max-width: ${breakpoints.ipad.pixels}) {
          border: 1px solid rgba(245, 164, 98, 0.8);
          border-radius: 30px;
          padding: 0 16px;
          line-height: 27px;
        }
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  padding: 32px 8%;
  align-items: center;
  background-color: rgba(245, 164, 98, 0.05);
  background-color: white;
  z-index: 10;
  & > div:first-of-type {
    max-width: 1440px;
    width: 100%;
    & > h2 {
      font-size: 35px;
      font-weight: 400;
      line-height: 36px;
      @media screen and (max-width: ${breakpoints.ipad.pixels}) {
        font-size: 24px;
        line-height: 28px;
      }
    }
  }

  & > div {
    max-width: 1440px;
    width: 100%;
    display: flex;
    flex-direction: column;
    & > h1 {
      color: #f5a462;
      margin: 64px 0;
      font-size: 45px;
      font-weight: 400;
      line-height: 36px;
      @media screen and (max-width: ${breakpoints.ipad.pixels}) {
        font-size: 24px;
        line-height: 20px;
        margin: 16px 0;
      }
    }
    & div {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 36px;
      max-height: 72px;
      margin: 8px 0;
      @media screen and (max-width: ${breakpoints.ipad.pixels}) {
        margin: 16px 0;
      }
      & > div {
        width: 36px;
        height: 36px;
        min-width: 36px;
        border-radius: 18px;
        background-color: #f5a462;
        margin: 0 16px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      & a {
        text-decoration: none;
        color: #4d4d4d;
        & > p {
          @media screen and (max-width: ${breakpoints.ipad.pixels}) {
            text-decoration: underline;
          }
          :hover {
            text-decoration: underline;
          }
        }
      }
      & p {
        margin: 0;
        line-height: 1;
        display: flex;
        align-items: center;
        font-size: 20px;
        font-weight: 400;
        line-height: 37px;
        @media screen and (max-width: ${breakpoints.ipad.pixels}) {
          font-size: 20px;
          line-height: 24px;
        }
        @media screen and (max-width: ${breakpoints.ipad.pixels}) {
          font-size: 16px;
          line-height: 20px;
        }
      }
    }
  }
`;

export const Space = styled.span`
  height: 32px;
`;

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 40px;
  top: 180px;

  @media screen and (max-width: 1200px) {
    & > div > svg {
      display: none;
    }
  }
`;

export const PallinoWrap = styled.div`
  position: sticky;
  width: 100vw;
  height: 0;
  top: 20px;
  z-index: 5;

  @media screen and (max-width: 1200px) {
    display: none;
  }
  & > svg:first-of-type {
    position: absolute;
    left: 25px;
    opacity: ${(props) => (props.opacity === "info" ? "1" : "0")};
    @media screen and (max-width: 1200px) {
      top: 32px;
    }
  }
  & > svg:nth-of-type(2) {
    position: absolute;
    left: 25px;
    opacity: ${(props) => (props.opacity === "video" ? "1" : "0")};
    @media screen and (max-width: 1200px) {
      top: 32px;
    }
  }
  & > svg:nth-of-type(3) {
    position: absolute;
    left: 25px;
    opacity: ${(props) => (props.opacity === "lezioni" ? "1" : "0")};
    @media screen and (max-width: 1200px) {
      top: 32px;
    }
  }
  & > svg:nth-of-type(4) {
    position: absolute;
    left: 25px;
    opacity: ${(props) => (props.opacity === "pallino" ? "1" : "0")};
    @media screen and (max-width: 1200px) {
      top: 32px;
    }
  }
`;
